<template>
  <div class="site-page">
    <div>
      <BundleList class="v-step-0" />
    </div>
    <div>
      <ServicesList class="v-step-1" />
    </div>
    <v-tour
      name="bundle-services-tour"
      :steps="steps"
      :options="tour_options"
      :callbacks="myCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import BundleList from "@/components/bundles-services/BundleList";
import ServicesList from "@/components/bundles-services/ServicesList";
export default {
  components: { BundleList, ServicesList },
  name: "BundleServices",
  data() {
    return {
      guided_tour: "",
      steps: [],
      tour_options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Passer",
          buttonPrevious: "Précédent",
          buttonNext: "Suivant",
          buttonStop: "Suivant",
        },
      },
      myCallbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onFinish: this.onFinish,
        onSkip: this.onSkip
      },
    };
  },
  created: function () {
    this.guided_tour = this.$store.state.core.first_login_configs.already_guided
    if (this.$store.state.core.first_login_configs.already_guided == false) {
      this.steps = this.$store.state.configs.guided_tour.plans_and_services.steps;
      this.steps = this.steps.map((element, index) => {
        return {
          target: `.v-step-${index}`,
          content: element.content,
          params: {
            placement: "bottom",
          },
        };
      });
    }
  },
  mounted: async function () {
    if (this.steps.length > 0 && this.$store.state.core.first_login_configs.already_guided == false) {

      this.$tours["bundle-services-tour"].start();
    }
  },
  methods: {
    myCustomPreviousStepCallback(currentStep) {
    },
    myCustomNextStepCallback(currentStep) {
    },
    onFinish() {
    if (this.$store.state.core.first_login_configs.already_guided == false) {
        this.$router.push({ name: "consumption" });
      }
    },
    onSkip () {
    if (this.$store.state.core.first_login_configs.already_guided == false) {
        this.$router.push({ name: "consumption" });
      }
    }
  },
};
</script>
<style scoped lang="css">
</style>
